<template>
  <div class="container booking">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>学长预约</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学长预约</h2>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="学长名称"
          prop="senior"
        >
          <el-input
            v-model="query.senior"
            placeholder="输入学长名称/手机号"
            @input="fetchBookingList(true)"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="学生名称"
          prop="user"
        >
          <el-input
            v-model="query.user"
            placeholder="输入学生昵称/手机号"
            @input="fetchBookingList(true)"
          ></el-input>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-date-picker
            class="datetime"
            v-model="createDatetime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="fetchBookingList(true)"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="支付状态"
          prop="status"
        >
          <el-select
            v-model="query.is_order_id"
            placeholder="请选择"
            clearable
            @change="fetchBookingList(true)"
          >
            <el-option
              label="已支付"
              value="1"
            > </el-option>
            <el-option
              label="未支付"
              value="0"
            > </el-option>
          </el-select>
        </el-form-item>
        <div class="divider"></div>
        <div class="search-footer">
          <el-form-item
            label="钉钉通知："
            prop="status"
          >
            <el-select
              v-model="notifyAdminIds"
              placeholder="请选择"
              clearable
              multiple
              style="width: 300px;"
              @change="notifyAdminIdsChange"
            >
              <el-option
                v-for="item in $store.state.adminList"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">预约列表</h3>
        <el-form
          label-width="70px"
          size="small"
        >
          <el-form-item style="">
            <el-radio-group
              v-model="query.status"
              @change="fetchBookingList(true)"
            >
              <el-radio-button
                v-for="(item, index) in filter.status"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="编号"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="学生ID"
            width="80"
            align="center"
          >
            <template
              slot-scope="scope"
              v-if="scope.row.user"
            >
              <span>{{ `${scope.row.user.id}` }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学生"
            min-width="160"
            align="center"
          >
            <template
              slot-scope="scope"
              v-if="scope.row.user"
            >
              <a
                :href="`/member/list?keyword=${scope.row.user.mobile}`"
                target="_blank"
                style="text-decoration: underline"
              ><span>{{
                  `${scope.row.user.nickname}/${scope.row.user.mobile?`/${scope.row.user.mobile}`:""}`
                }}</span></a>
            </template>
          </el-table-column>
          <el-table-column
            label="学长ID"
            width="80"
            align="center"
          >
            <template
              slot-scope="scope"
              v-if="scope.row.senior"
            >
              <span>{{ `${scope.row.senior.uid}` }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学长"
            min-width="160"
            align="center"
          >
            <template
              slot-scope="scope"
              v-if="scope.row.senior"
            >
              <a
                :href="`/senior/list?keyword=${scope.row.senior.mobile}`"
                target="_blank"
                style="text-decoration: underline"
              ><span>{{
                  `${scope.row.senior.realname||scope.row.senior.nickname||""}${scope.row.senior.mobile?`/${scope.row.senior.mobile}`:""}`
                }}</span></a>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="预约状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ handleRender(scope.row.status, "status") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="支付状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="small"
                type="success"
                v-show="scope.row.order_id"
              >已支付</el-tag>
              <el-tag
                size="small"
                type="info"
                v-show="!scope.row.order_id"
              >未支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status == 0"
                size="mini"
                type="text"
                @click="handleDoing(scope.row, scope.$index)"
              >跟进</el-button>
              <el-button
                v-if="scope.row.status >= 1"
                size="mini"
                type="text"
                :disabled="scope.row.status == 2"
                @click="handleDone(scope.row, scope.$index)"
              >完结</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                    v-if="scope.row.status == 0"
                  ><span
                      @click="handleDoing(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      跟进
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                    v-if="scope.row.status >= 1"
                  ><span
                      @click="handleDone(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      完结
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { seniorBookingList, seniorBookingUpdate } from "@/api/senior";
import { configureOne, configureCreate, configureUpdate } from '@/api/operation'


export default {
  components: {},
  data() {
    return {
      query: {
        status: "0",
        user: "",
        senior: "",
        startTime: "",
        endTime: "",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      createDatetime: "",
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "待跟进", value: 0 },
          { label: "跟进中", value: 1 },
          { label: "已完结", value: 2 },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      notifyAdminIds: false,
      SeniorBookingNotifyAdminIds: {},
    };
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf();
        this.query.endTime = this.$moment(value[1]).valueOf();
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
    },
  },
  created() {
    this.parseQuery();
    this.fetchBookingList();
    this.$store.dispatch('getAdminList')
    this.fetchConfigure()
  },
  methods: {
    fetchConfigure() {
      configureOne({ code: 'SeniorBookingNotifyAdminIds' }).then((res) => {
        this.SeniorBookingNotifyAdminIds = res
        this.notifyAdminIds = res.value ? res.value.split(',').map((v) => { return Number(v) }) : []
      });
    },
    // 学长订单列表请求
    fetchBookingList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      seniorBookingList(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    handleRender(value, type) {
      let status = {
        0: "待跟进",
        1: "跟进中",
        2: "已完结",
      };
      if (type == "status") {
        return status[value] || "";
      }
      return "";
    },
    // 状态渲染
    statusRender(row) {
      const pay_status = {
        0: "待支付",
        1: "已支付",
        2: "已退款",
      };
      return pay_status[row.order.pay_status] || "";
    },
    handleInfo() {
      this.dialogVisible = true;
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchBookingList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchBookingList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchBookingList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      // 手动处理
      this.createDatetime = null;
      setTimeout(() => {
        this.fetchBookingList();
      }, 20);
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ];
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    // 变更状态 跟进中
    handleDoing(row) {
      seniorBookingUpdate({ id: row.id, status: 1 }).then((res) => {
        this.$message.success(`状态已变更`);
        this.fetchBookingList();
      });
    },
    // 变更状态 完结
    handleDone(row) {
      seniorBookingUpdate({ id: row.id, status: 2 }).then((res) => {
        this.$message.success(`状态已变更`);
        this.fetchBookingList();
      });
    },
    notifyAdminIdsChange(e) {
      configureUpdate(Object.assign({}, this.SeniorBookingNotifyAdminIds, { value: e.join(',') })).then((res) => {

      });
    }
  },
};
</script>

<style scoped lang="less">
.booking {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 32px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        font-size: 14px;
        padding: 12px 20px;
      }
    }
  }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
